import * as React from "react"

// Matches Tailwind's `md` breakpoint: everything narrower renders the phone
// layouts (drawer navigation, single-column pages).
export const MOBILE_BREAKPOINT = 768

const query = () => window.innerWidth < MOBILE_BREAKPOINT

export function useIsMobile() {
  // Initialised synchronously (this is a client-only SPA) so the first paint
  // already picks the right layout instead of flashing the desktop sidebar.
  const [isMobile, setIsMobile] = React.useState<boolean>(query)

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      setIsMobile(query())
    }
    mql.addEventListener("change", onChange)
    setIsMobile(query())
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
